<template>
    <div class="pagination-area">
        <div class="pagination--items desktop-only">
            <div class="form-item form-item-select">
                <label for="pagination_items"
                       class="form-label">Items per page</label>
                <div class="select-outer">
                    <input type="text"
                           id="pagination_items"
                           name="items"
                           v-model="items"
                           @click="openList = true"
                           @focus="openList = true"
                           @blur="openList = hoverList ? true : false"
                           :readonly="true"
                           :disabled="loader">
                    <ul v-show="openList && !loader">
                        <li v-for="(items, index) in paginationOptions" @click="setItems(index), openList = false" @mouseover="hoverList = true" @mouseleave="hoverList = false">{{ items }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="pagination--page">
            <ul>
                <li v-if="currentPage > 1"
                    @click="setPage(1); goToTop()">
                    <i class="mdi mdi-chevron-double-left"></i>
                </li>
                <li v-if="currentPage > 1"
                    @click="setPage(currentPage - 1); goToTop()">
                    <i class="mdi mdi-chevron-left"></i>
                </li>
                <li v-if="currentPage > 1"
                    @click="setPage(currentPage - 1); goToTop()">
                    {{ currentPage - 1 }}
                </li>
                <li class="active" style="cursor: default">
                    {{ currentPage }}
                </li>
                <li v-if="currentPage < numberOfPages"
                    @click="setPage(currentPage + 1); goToTop()">
                    {{ currentPage +  1 }}
                </li>
                <li v-if="currentPage !== numberOfPages"
                    @click="setPage(currentPage + 1); goToTop()">
                    <i class="mdi mdi-chevron-right"></i>
                </li>
                <li v-if="currentPage !== numberOfPages"
                    @click="setPage(numberOfPages); goToTop()">
                    <i class="mdi mdi-chevron-double-right"></i>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['currentPage', 'items', 'loader', 'numberOfPages', 'setItems', 'setPage'],
        data () {
            return {
                openList            : false,
                paginationOptions   : {
                    25: 25,
                    50: 50,
                    100: 100
                }
            }
        },
        methods: {
            goToTop () {
                window.scrollTo(0, 0);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/shared/pagination/Pagination.component.vue